module.exports = __webpack_public_path__ + "static/media/YM06_3.9234c2c5.jpg";